import React from 'react';
import ContentWrapper from "../../components/Content";
import contents from './contents';

const TrustAndSafetyPage = () => {
    return (
        <ContentWrapper contents={contents} title='TRUST AND SAFETY'>
            <section>
                <p>PowerPlay Systems Inc (PowerPlay Systems) is committed to providing a fair and transparent ecosystem for all users of our Powerplay Systems Website. It’s our job to ensure that our contest participants can be confident in the integrity of every contest, every day.</p>
            </section>
        </ContentWrapper>
    )
}

export default TrustAndSafetyPage